// extracted by mini-css-extract-plugin
export default {"contents":"cG-z","sectionHeading":"dG-z"};